import styled from "@emotion/styled";
import Colors from "styles/colors";
import Constants from "./constants";
const BORDER_BOTTOM = `1px solid ${Colors["dark-marble"]}`;
const NAV_ITEM_HEIGHT = `${Constants.MENU_ITEM_TITLE_HEIGHT}px`;
export const StyledHeaderMenuComponent = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${Colors["white"]};
  user-select: none;
  overflow: hidden;

  .menu-nav-container {
    position: relative;
    height: 100%;
    width: 100%;

    &.is-submenu-active .menu-nav--main {
      visibility: hidden;
      pointer-events: none;
    }
  }

  .menu-nav {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 0 24px 80px;
    background-color: ${Colors["white"]};
  }

  .menu-nav--submenu {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    opacity: 0;
    pointer-events: none;
    transition: opacity 400ms ease;

    &.is-submenu-active {
      opacity: 1;
      pointer-events: auto;

      @keyframes submenuSectionFadeIn {
        from {
          opacity: 0;
          transform: translateY(10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .submenu-stagger-item:nth-of-type(1) {
        animation: submenuSectionFadeIn 0.25s ease-out 0ms both;
      }
      .submenu-stagger-item:nth-of-type(2) {
        animation: submenuSectionFadeIn 0.25s ease-out 50ms both;
      }
      .submenu-stagger-item:nth-of-type(3) {
        animation: submenuSectionFadeIn 0.25s ease-out 100ms both;
      }
      .submenu-stagger-item:nth-of-type(4) {
        animation: submenuSectionFadeIn 0.25s ease-out 150ms both;
      }
      .submenu-stagger-item:nth-of-type(5) {
        animation: submenuSectionFadeIn 0.25s ease-out 200ms both;
      }
      .submenu-stagger-item:nth-of-type(6) {
        animation: submenuSectionFadeIn 0.25s ease-out 250ms both;
      }
      .submenu-stagger-item:nth-of-type(7) {
        animation: submenuSectionFadeIn 0.25s ease-out 300ms both;
      }
      .submenu-stagger-item:nth-of-type(8) {
        animation: submenuSectionFadeIn 0.25s ease-out 350ms both;
      }
      .submenu-stagger-item:nth-of-type(9) {
        animation: submenuSectionFadeIn 0.25s ease-out 400ms both;
      }
      .submenu-stagger-item:nth-of-type(10) {
        animation: submenuSectionFadeIn 0.25s ease-out 450ms both;
      }
    }
  }

  .menu-nav-item,
  .submenu-nav-item {
    color: ${Colors["Black"]};
  }

  .submenu-nav-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: ${NAV_ITEM_HEIGHT};
    border-bottom: ${BORDER_BOTTOM};
    font-size: 1.25rem;
    cursor: pointer;
    flex-shrink: 0;

    .submenu-nav-item-arrow {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      color: ${Colors["Black"]};
    }

    &:hover {
      color: ${Colors["brand-iris"]};

      .submenu-nav-item-arrow {
        color: ${Colors["brand-iris"]};
      }
    }
  }

  .download-mobile-app-component-wrapper {
    margin-top: 32px;
  }

  .monday-link-wrapper {
    display: flex;
    gap: 10px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 28px;

    .picture-component {
      img {
        max-height: 20px;
        vertical-align: bottom;

        // The old PNG pads its dots to a 20px box (ink ~12.4px tall). The new SVG is ink
        // edge to edge, so draw it at the old ink height and keep the 20px box.
        &.new-brand-mark {
          max-height: none;
          height: 12.5px;
          margin: 3.75px 0;
        }
      }
    }

    .monday-link-text-wrapper {
      justify-content: center;
      vertical-align: middle;

      .secondary-button-text {
        font-weight: 400;
      }

      .secondary-button {
        line-height: 24px;

        a {
          &.with-underline {
            background: none;
          }
        }
      }
    }
  }
`;
